module.exports = __webpack_public_path__ + "static/media/bkg02n.00577ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg02n.jpg
// module id = 466
// module chunks = 0